export function getdata(){
	var obj = {
		
			headDataI:[
				{
					title: "项目",
					prop: "title",
					width:"240px",
					custom:true,
				},
				{
					title: "栏次",
					prop: "grade",
					width:"96px",
					custom:true,
				},
				{
					title: "份数",
					prop: "zzs_2_x_1",
					custom:true,
					width:"110px",
				},
				{
					title: "金额",
					prop: "zzs_2_x_2",
					custom:true,
					width:"110px",
				},
				{
					title: "税额",
					prop: "zzs_2_x_3",
					custom:true,
					width:"110px",
				},
			],
			tableDataI:[
				{
					title:"（一）认证相符的增值税专用发票",
					grade:"1=2+3",
					disabledzzs_2_x_1:true,
					disabledzzs_2_x_2:true,
					disabledzzs_2_x_3:true,
				},
				{
					title:"其中：本期认证相符且本期申报抵扣",
					grade:"2",
				},
				{
					title:"前期认证相符且本期申报抵扣",
					grade:"3",
				},
				{
					title:"（二）其他扣税凭证",
					grade:"4=5+6+7+8a+8b",
					disabledzzs_2_x_1:true,
					disabledzzs_2_x_2:true,
					disabledzzs_2_x_3:true,
				},
				{
					title:"其中：海关进口增值税专用缴款书",
					grade:"5",
				},
				{
					title:"农产品收购发票或者销售发票",
					grade:"6",
				},
				{
					title:"代扣代缴税收缴款凭证",
					grade:"7",
					disabledzzs_2_x_2:true,
				},
				{
					title:"加计扣除农产品进项税额",
					grade:"8a",
					disabledzzs_2_x_1:true,
					disabledzzs_2_x_2:true,
					zzs_2_x_1:{
						cellVal:""
					},
					zzs_2_x_2:{
						cellVal:""
					},
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"其他",
					grade:"8b",
					zzs_2_x_1:{
						cellVal:""
					},
					zzs_2_x_2:{
						cellVal:""
					},
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"（三）本期用于购建不动产的扣税凭证",
					grade:"9",
					zzs_2_x_1:{
						cellVal:"" 
					},
					zzs_2_x_2:{
						cellVal:""
					},
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"（四）本期用于抵扣的旅客运输服务扣税凭证",
					grade:"10",
					zzs_2_x_1:{
						cellVal:""
					},
					zzs_2_x_2:{
						cellVal:""
					},
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"（五）外贸企业进项税额抵扣证明",
					grade:"11",
					disabledzzs_2_x_1:true,
					disabledzzs_2_x_2:true,
					zzs_2_x_1:{
						cellVal:""
					},
					zzs_2_x_2:{
						cellVal:""
					},
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"当期申报抵扣进项税额合计",
					grade:"12=1+4+11",
					disabledzzs_2_x_1:true,
					disabledzzs_2_x_2:true,
					disabledzzs_2_x_3:true,
					zzs_2_x_1:{
						cellVal:""
					},
					zzs_2_x_2:{
						cellVal:""
					},
					zzs_2_x_3:{
						cellVal:""
					},
				}
			],
			headDataII:[
				{
					title: "项目",
					prop: "title",
					width:"240px",
					custom:true,
				},
				{
					title: "栏次",
					prop: "grade",
					width:"96px",
					custom:true,
				},
				{
					title: "税额",
					prop: "zzs_2_x_3",
					custom:true,
					width:"440px",
				},
			],
			tableDataII:[
				{
					title:"本期进项税额转出额",
					grade:"13=14至23之和",
					disabledzzs_2_x_3:true,
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"其中：免税项目用",
					grade:"14",
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"集体福利、个人消费",
					grade:"15",
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"非正常损失",
					grade:"16",
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"简易计税方法征税项目用",
					grade:"17",
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"免抵退税办法不得抵扣的进项税额",
					grade:"18",
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"纳税检查调减进项税额",
					grade:"19",
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"红字专用发票信息表注明的进项税额",
					grade:"20",
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"上期留抵税额抵减欠税",
					grade:"21",
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"上期留抵税额退税",
					grade:"22",
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"异常凭证转出进项税额",
					grade:"23a",
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"其他应作进项税额转出的情形",
					grade:"23b",
					zzs_2_x_3:{
						cellVal:""
					},
				},
				
			],
			headDataIII:[
				{
					title: "项目",
					prop: "title",
					width:"240px",
					custom:true,
				},
				{
					title: "栏次",
					prop: "grade",
					width:"96px",
					custom:true,
				},
				{
					title: "份数",
					prop: "zzs_2_x_1",
					custom:true,
					width:"110px",
				},
				{
					title: "金额",
					prop: "zzs_2_x_2",
					custom:true,
					width:"110px",
				},
				{
					title: "税额",
					prop: "zzs_2_x_3",
					custom:true,
					width:"110px",
				},
			],
			tableDataIII:[
				{
					title:"（一）认证相符的增值税专用发票",
					grade:"24",
					disabledzzs_2_x_1:true,
					disabledzzs_2_x_2:true,
					disabledzzs_2_x_3:true,
					zzs_2_x_1:{
						cellVal:""
					},
					zzs_2_x_2:{
						cellVal:""
					},
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"期初已认证相符但未申报抵扣",
					grade:"25",
					zzs_2_x_1:{
						cellVal:""
					},
					zzs_2_x_2:{
						cellVal:""
					},
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"本期认证相符且本期未申报抵扣",
					grade:"26",
					zzs_2_x_1:{
						cellVal:""
					},
					zzs_2_x_2:{
						cellVal:""
					},
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"期末已认证相符但未申报抵扣",
					grade:"27",
					zzs_2_x_1:{
						cellVal:""
					},
					zzs_2_x_2:{
						cellVal:""
					},
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"其中：按照税法规定不允许抵扣",
					grade:"28",
					zzs_2_x_1:{
						cellVal:""
					},
					zzs_2_x_2:{
						cellVal:""
					},
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"（二）其他扣税凭证",
					grade:"29=30至33之和",
					disabledzzs_2_x_1:true,
					disabledzzs_2_x_2:true,
					disabledzzs_2_x_3:true,
					zzs_2_x_1:{
						cellVal:""
					},
					zzs_2_x_2:{
						cellVal:""
					},
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"其中：海关进口增值税专用缴款书",
					grade:"30",
					zzs_2_x_1:{
						cellVal:""
					},
					zzs_2_x_2:{
						cellVal:""
					},
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"农产品收购发票或者销售发票",
					grade:"31",
					zzs_2_x_1:{
						cellVal:""
					},
					zzs_2_x_2:{
						cellVal:""
					},
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"代扣代缴税收缴款凭证",
					grade:"32",
					disabledzzs_2_x_2:true,
					zzs_2_x_1:{
						cellVal:""
					},
					zzs_2_x_2:{
						cellVal:""
					},
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"其他",
					grade:"33",
					zzs_2_x_1:{
						cellVal:""
					},
					zzs_2_x_2:{
						cellVal:""
					},
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"",
					grade:"34",
					zzs_2_x_1:{
						cellVal:""
					},
					zzs_2_x_2:{
						cellVal:""
					},
					zzs_2_x_3:{
						cellVal:""
					},
				},
			],
			headDataIV:[
				{
					title: "项目",
					prop: "title",
					width:"240px",
					custom:true,
				},
				{
					title: "栏次",
					prop: "grade",
					width:"96px",
					custom:true,
				},
				{
					title: "份数",
					prop: "zzs_2_x_1",
					custom:true,
					width:"110px",
				},
				{
					title: "金额",
					prop: "zzs_2_x_2",
					custom:true,
					width:"110px",
				},
				{
					title: "税额",
					prop: "zzs_2_x_3",
					custom:true,
					width:"110px",
				},
			],
			tableDataIV:[
				{
					title:"本期认证相符的增值税专用发票",
					grade:"35",
					
					zzs_2_x_1:{
						cellVal:""
					},
					zzs_2_x_2:{
						cellVal:""
					},
					zzs_2_x_3:{
						cellVal:""
					},
				},
				{
					title:"代扣代缴税额",
					grade:"36",
					disabledzzs_2_x_1:true,
					disabledzzs_2_x_2:true,
					zzs_2_x_1:{
						cellVal:""
					},
					zzs_2_x_2:{
						cellVal:""
					},
					zzs_2_x_3:{
						cellVal:""
					},
				},
			]
		
	}
	return obj
}
